<i18n>
{
  "en": {
    "saleZone": "Restaurant sale zones"
  },
  "es": {
    "saleZone": "Zonas del restaurante"
  }
}
</i18n>

<template>
  <fragment>
    <v-container>
      <div class="d-flex justify-center | header">
        <div class="justify-content-center font-weight-bold ma-1 text-md-h6 text-body-1"> {{ $t('saleZone') }}</div>
      </div>
      <v-virtual-scroll item-height="75" bench="20" :items="saleZoneList" class="scroll">
          <template v-slot:default="{ item }">
            <master-sale-zone-row :key="item.guid" :saleZone="item" @preview-qrcode="onPreviewQRCode"
            @download-qrcode="onDownloadAllSaleZoneQRCodes"/>
          </template>
      </v-virtual-scroll>
      <dynameat-skeleton v-if="isLoading" skeleton-type="menuList" :container="false"/>
      <master-sale-zone-modal v-if="saleZoneSelected" :visible="qrCodesModalVisible"
                              :saleZone="saleZoneSelected" @close="closeSaleZoneModal"
                              @download-sale-zone-qrs="onDownloadAllSaleZoneQRCodes"/>
    </v-container>
  </fragment>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import DynameatSkeleton from '@dynameat/components/DynameatSkeleton';
import MasterSaleZoneRow from './components/MasterSaleZoneRow.vue';
import MasterSaleZoneModal from './components/MasterSaleZoneModal.vue';

@Component
@Components({ DynameatSkeleton, MasterSaleZoneModal, MasterSaleZoneRow })
@MapGetters(['isLoading', 'saleZoneList'])
export default class MasterSaleZoneList extends Vue {
  qrCodesModalVisible = false;

  saleZoneSelected = null;

  onPreviewQRCode(saleZone) {
    this.saleZoneSelected = saleZone;
    this.qrCodesModalVisible = true;
  }

  onDownloadAllSaleZoneQRCodes(saleZone) {
    saleZone.downloadAllQRCodes();
  }

  closeSaleZoneModal() {
    this.saleZoneSelected = null;
    this.qrCodesModalVisible = false;
  }
}

</script>
